import { render, staticRenderFns } from "./VariablesUsages.vue?vue&type=template&id=b4fe7e8a&scoped=true&"
import script from "./VariablesUsages.vue?vue&type=script&lang=js&"
export * from "./VariablesUsages.vue?vue&type=script&lang=js&"
import style0 from "./VariablesUsages.vue?vue&type=style&index=0&id=b4fe7e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fe7e8a",
  null
  
)

export default component.exports